import { render, staticRenderFns } from "./CategoryCatalog.vue?vue&type=template&id=14cddd2d&scoped=true&name=category-catalog&"
import script from "./CategoryCatalog.vue?vue&type=script&lang=js&"
export * from "./CategoryCatalog.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCatalog.vue?vue&type=style&index=0&id=14cddd2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cddd2d",
  null
  
)

export default component.exports